import script from "./cTableList.vue?vue&type=script&setup=true&lang=js"
export * from "./cTableList.vue?vue&type=script&setup=true&lang=js"

import "./cTableList.vue?vue&type=style&index=0&id=57f827ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57f827ec"]])

export default __exports__